import PropTypes from 'prop-types'
import React from 'react'

import { AddToCartButton, AddToCartNotice, BuyboxQuantityField } from '../../templateComponents/Buybox'
import AddToWishlistLink from '../../templateComponents/AddToWishlistLink'
import VariationSelection from '../../templateComponents/VariationSelection'

export default function Buybox({ t, product, isBeyondShop }) {
  return (
    <div className="product-info-buybox">
      {(product.stockLevelClass || product.deliveryPeriod) && (
        <div className="stocklevel">
          {product.stockLevelClass && (
            <div className="product-availability show-stock-level">
              {product.availabilityText.includes('NOT_AVAILABLE') ? (
                <strong className="product-availability-info">{t(product.availabilityText)}</strong>
              ) : (
                <>
                  <span className={`product-availability-icon ${product.stockLevelClass}-stock-icon`} />
                  <span className="product-availability-info">{t(product.availabilityText)}</span>
                </>
              )}
            </div>
          )}
          {product.deliveryPeriod && !product.availabilityText.includes('NOT_AVAILABLE') && (
            <div>
              <span className="product-delivery-info">
                {t('components.productComponent.productDeliveryPeriod', {
                  period: product.deliveryPeriod,
                  unit: product.deliveryPeriodUnit,
                })}
              </span>
              <span className="product-delivery-icon" />
            </div>
          )}
        </div>
      )}
      {(product.variations || {}).items && (
        <div className="variations-attribute">
          <VariationSelection product={product} key={product.slug} />
        </div>
      )}

      {!product.isVariationMaster && (
        <BuyboxQuantityField min={1} className="product-quantity-field" withLabel={true} />
      )}

      <div className="product-button-container">
        <AddToCartButton className="product-add-cart-button">
          {t('components.productComponent.addToBasketButton.label')}
        </AddToCartButton>
        {!isBeyondShop && !product.isVariationMaster && (
          <AddToWishlistLink className="product-add-wishlist-link" productId={product.productId}>
            {t('components.productComponent.addToWishlistLink.label')}
          </AddToWishlistLink>
        )}
      </div>
      <AddToCartNotice />
    </div>
  )
}

Buybox.propTypes = {
  t: PropTypes.func.isRequired,
  isBeyondShop: PropTypes.bool.isRequired,
  product: PropTypes.shape({
    isVariationMaster: PropTypes.bool,
    productId: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    deliveryPeriod: PropTypes.string,
    deliveryPeriodUnit: PropTypes.string,
    availabilityText: PropTypes.string.isRequired,
    stockLevelClass: PropTypes.string,
    variations: PropTypes.shape({
      items: PropTypes.any,
    }),
  }).isRequired,
}
